<template>
	<div class="psv">
		<div class="psv__elm">
			<!-- //////////////// -->
			<!-- PAYMENT FAIL -->
			<FailPayment />
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import FailPayment from "@/components/payment/FailPayment.vue";
import { mapActions, mapGetters } from "vuex";

@Options({
	components: { FailPayment },
	computed: {
		...mapGetters("paymentModule", {
			payFail: "payFailGetters",
		}),
	},

	methods: {
		...mapActions("paymentModule", ["payFailAction"]),
	},
})
export default class PaymentFailView extends Vue {
	// ************************************************************
	// Define mapGetters
	public payFail: { id: number };

	// ************************************************************
	// Define mapActions
	public payFailAction!: (payload: {
		id: number;
		payType: number;
	}) => Promise<void>;

	/**
	 * Hook mounted
	 */
	public async mounted() {
		const orderId = Number(this.$route.params.orderId);
		const payType = Number(this.$route.params.payType);

		// После того как оплата не удалась на сайте TBank, отправляем запрос на смену статуса в таблице payment
		await this.payFailAction({ id: orderId, payType: payType });

		if (this.payFail.id === 0) {
			this.redirect("page-not-found");
		}
	}

	/**
	 * Переход на другую страницу
	 * @param routeName
	 * @param id
	 */
	public redirect(routeName: string, id?: number) {
		this.$router.push({ name: routeName, params: { id: id } });
	}
}
</script>

<style scoped lang="scss">
.psv {
	display: flex;
	justify-content: center;

	&__elm {
		padding-top: 24px;
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		max-width: 649px;
	}

	@media screen and (max-width: 768px) {
		&__elm {
			display: flex;
			flex-direction: column;
			flex-grow: 1;
			padding: 12px;
			min-width: 100px;
		}
	}
}
</style>
